import React, { useEffect, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { Button, Col, Row } from "react-bootstrap";
import { alertClickBack } from "../../components/alertValid/AlertValid.js"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { getJobApplicants, getJobApplicantsByID } from "../../api/job_app.js";
import { Link, useNavigate } from 'react-router-dom';
import {formatDate} from "../../utils/formatDate.js";

function ViewJobApplicants() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [nationality, setNationality] = useState("");
    const [fullName, setFullName] = useState("");
    const [gender, setGender] = useState("");
    const [dateBirth, setDateBirth] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [address , setAddress ] = useState("");
    const [fileResume, setFileResume] = useState();
    const [educationalStatus, setEducationalStatus] = useState("");
    const [degree, setDegree] = useState("");
    const [educationalInstitution,  setEducationalInstitution] = useState("");
    const [imgProfile, setImgProfile] = useState();

    async function getDataJobApplicants(id) {
        try {
          await setLoading(true);
          let res = await getJobApplicantsByID(id);
          setTimeout(async () => {
            await setLoading(false);
          }, 1000);

          setNationality(res.data.data.nationality);
          setFullName(res.data.data.fullname);
          setGender(res.data.data.gender);
          setDateBirth(formatDate(res.data.data.dateofbirth));
          setPhone(res.data.data.phonenumber);
          setEmail(res.data.data.email);
          setAddress(res.data.data.address);
          setFileResume(res.data.data.cv_path);
          setEducationalStatus(res.data.data.education_status);
          setDegree(res.data.data.degree);
          setEducationalInstitution(res.data.data.education_institute);
          setImgProfile(res.data.data.img)
        } catch (error) {}
      }

      const navigate = useNavigate();
      const navigateToBack = (page) => {
          navigate(page);
      };
      
      const handleClickBack = async () => {
        const res = await alertClickBack();
            if (res.isConfirmed) {
              navigateToBack("/infoJobApplicants");
            }
            else { }
      };

      useEffect(() => {
        let id = new URLSearchParams(window.location.search).get("id");
        if (id) {
        }
        getDataJobApplicants(id);
      }, []);

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"CAREER JOB"} />
        <Menu
            parentmenu={"infoCareerJob"}
            activemenu={"infoJobApplicants"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-careers.png" className="ic-user01 me-2" alt="" />
                                VIEW JOB APPLICANTS
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-3'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Job Career
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Nationality :
                                </label>
                            </Col>
                            <Col xs={9}>
                                <font className="fontLight font-size03 colorBlack01">
                                {nationality}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Personal Information
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={12}><img src={imgProfile} className='im-profile' alt='profile'/></Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Full Name :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {fullName}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Gender :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {gender}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Date of Birth :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {dateBirth}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Phone Number :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {phone}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Email :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {email}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Address :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {address}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                ไฟล์ Resume :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <Link to={fileResume} target='_blank' className="fontLight font-size03 colorBlue01 file-link">
                                {fileResume}
                                </Link>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Education Information
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Major :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {educationalStatus}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Degree :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {degree}
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={3}>
                                <label className="fontLight font-size03 colorBlack01">
                                Educational Institution :
                                </label>
                            </Col>
                            <Col xs={9}> 
                                <font className="fontLight font-size03 colorBlack01">
                                {educationalInstitution}
                                </font>
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                    <button
                        className="btn-cancle01"
                        onClick={() => handleClickBack()}
                    >
                        BACK
                    </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default ViewJobApplicants;